import { FACTORY_OPTION } from "~/pages/Editor/EditorServiceAuthorization/options";

export enum ESubType {
  input = "input",
  indicator = "indicator",
}

export const SUB_OPTIONS = {
  services: [
    "Code",
    "Name",
    "ComplianceIndicatorId",
    "FactIndicatorId",
    "CertificationDateIndicatorId",
    "FactContractIndicatorId",
    "ActualFrom",
  ],
  requiredTools: [
    "Number",
    "Name",
    "ComplianceIndicatorId",
    "ModelIndicatorId",
    "TotalIndicatorId",
    "CheckedDateIndicatorId",
    "ActualFrom",
  ],
  toolsInsurance: [
    "Number",
    "NumberList",
    "NumberDetail",
    "Name",
    "ComplianceIndicatorId",
    "TotalIndicatorId",
    "GroupOne",
    "ActualFrom",
  ],
  toolsMetrological: [
    "Number",
    "Name",
    "ComplianceIndicatorId",
    "TotalIndicatorId",
    "ActualFrom",
  ],
  tools: [
    "Number",
    "Name",
    "ComplianceIndicatorId",
    "TotalIndicatorId",
    "ModelIndicatorId",
    "CountryIndicatorId",
    "YearIndicatorId",
    "NoteIndicatorId",
    "GroupOne",
    "ActualFrom",
  ],
  warehouses: [
    "Number",
    "Name",
    "AreaIndicatorId",
    "CombineIndicatorId",
    "ComplianceIndicatorId",
    "ActualFrom",
  ],
  places: [
    "Number",
    "Name",
    "GroupOne",
    "ComplianceIndicatorId",
    "AreaIndicatorId",
    "PlacesCombineIndicatorId",
    "ActualFrom",
  ],
  placePosts: [
    "ZD_PlacesId",
    "Name",
    "ComplianceIndicatorId",
    "TotalIndicatorId",
    "ActualFrom",
  ],
  personal: [
    "Number",
    "Name",
    "DocName",
    "ComplianceIndicatorId",
    "PersonNameIndicatorId",
    "PositionIndicatorId",
    "PositionStartIndicatorId",
    "StudyCertificateDateIndicatorId",
    "ImageIndicatorId",
    "ActualFrom",
  ],
  notes: [
    "Number",
    "Name",
    "ComplianceIndicatorId",
    "ImageIndicatorId",
    "ActualFrom",
  ],
  tradePremises: [
    "Number",
    "Name",
    "GroupOne",
    "AddressIndicatorId",
    "AreaIndicatorId",
    "ComplianceIndicatorId",
    "ActualFrom",
  ],
};

const optionsAnalyzer = (options, subOptions) => {
  return options.reduce((acc, option) => {
    acc[option] = subOptions[option].reduce((acc, subOption) => {
      acc = [
        ...acc,
        {
          name: subOption,
          type:
            subOption.substr(-2, 2) === "Id" || subOption === "GroupOne"
              ? ESubType.indicator
              : ESubType.input,
        },
      ];
      return acc;
    }, []);
    return acc;
  }, {});
};

const optionsAnalyzerPeriod = (options, subOptions) => {
  return options.reduce((acc, option) => {
    acc[option] = subOptions[option].reduce((acc, subOption) => {
      acc = subOption.substr(-2, 2) === "Id" ? [...acc, subOption] : acc;
      return acc;
    }, []);
    return acc;
  }, {});
};

export const TABLE_REDUCER_OPTIONS = {
  ...optionsAnalyzer(FACTORY_OPTION, SUB_OPTIONS),
};

export const TABLE_REDUCER_OPTIONS_PERIOD = {
  ...optionsAnalyzerPeriod(FACTORY_OPTION, SUB_OPTIONS),
};
